export const shouldAskBeforeLeaving = (route) =>
  route.unSavedForm || route.isMobileTransfer;
